import { render, staticRenderFns } from "./newDetailView.vue?vue&type=template&id=3d6c13bb&scoped=true&"
import script from "./newDetailView.js?vue&type=script&lang=js&"
export * from "./newDetailView.js?vue&type=script&lang=js&"
import style0 from "./newDetailView.scss?vue&type=style&index=0&id=3d6c13bb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d6c13bb",
  null
  
)

export default component.exports